export const messages = {
  en: {
    propertyCommunity: {
      search: {
        title: 'Search Conditions',
        communityId: 'Please enter community ID',
        name: 'Please enter community name'
      },
      list: {
        title: 'Community Information',
        add: 'Join Community',
        quit: 'Quit Community'
      },
      table: {
        communityId: 'Community ID',
        name: 'Community Name',
        nearbyLandmarks: 'Nearby Landmarks',
        cityCode: 'City Code',
        state: 'Status'
      },
      add: {
        title: 'Add Community',
        openCommunity: 'Open Community',
        selectCommunity: 'Optional, please select community',
        functions: 'Functions',
        all: 'All'
      },
      edit: {
        title: 'Edit Community',
        openCommunity: 'Open Community',
        functions: 'Functions',
        all: 'All'
      },
      delete: {
        title: 'Confirm Operation',
        confirm: 'Are you sure to quit this community?',
        cancel: 'Cancel',
        confirmButton: 'Confirm Quit'
      },
      fetchError: 'Failed to fetch community data'
    },

  },
  zh: {
    propertyCommunity: {
      search: {
        title: '查询条件',
        communityId: '请输入园区编号',
        name: '请输入园区名称'
      },
      list: {
        title: '园区信息',
        add: '加入园区',
        quit: '退出园区'
      },
      table: {
        communityId: '园区ID',
        name: '园区名称',
        nearbyLandmarks: '附近地标',
        cityCode: '城市编码',
        state: '状态'
      },
      add: {
        title: '添加园区',
        openCommunity: '开通园区',
        selectCommunity: '选填，请选择开通园区',
        functions: '功能',
        all: '全部'
      },
      edit: {
        title: '修改园区',
        openCommunity: '开通园区',
        functions: '功能',
        all: '全部'
      },
      delete: {
        title: '请确认您的操作',
        confirm: '确定退出园区吗？',
        cancel: '点错了',
        confirmButton: '确认退出'
      },
      fetchError: '获取园区数据失败'
    },
  }
}